const faqData = [
    {
        question: "Le handicap, c’est quoi et qui est concerné ?",
        answer: `
            Le handicap désigne toute limitation physique, sensorielle, mentale ou psychique qui impacte la vie quotidienne ou professionnelle. 
            Il peut être visible (mobilité réduite, déficience visuelle…) ou invisible (maladies chroniques, troubles psychiques…). 
            Toute personne ayant des difficultés dans un environnement de travail peut être concernée, qu’elle ait un handicap temporaire ou permanent.  
        `,
    },
    {
        question: "Intérêt d’être Bénéficiaire de l’Obligation d’Emploi des Travailleurs Handicapés (BOETH) ? Les aides possibles ?",
        answer: `
            Être Bénéficiaire de l’Obligation d’Emploi des Travailleurs Handicapés (BOETH) permet de bénéficier d’un accompagnement spécifique pour favoriser votre maintien dans l’emploi ou votre insertion professionnelle. 
            Les avantages incluent des aménagements de poste, un accès prioritaire à certaines formations, et des aides financières pour compenser les besoins liés au handicap. 
            Les employeurs, eux, sont encouragés à recruter et soutenir les collaborateurs reconnus BOETH.
        `,
    },
    {
        question: "Comment obtenir la Reconnaissance de la Qualité de Travailleur Handicapé (RQTH) et qui peut m’aider ?",
        answer: `
            La RQTH se demande auprès de la MDPH (Maison Départementale des Personnes Handicapées) via un dossier détaillant votre situation médicale et professionnelle.
            Vous pouvez être accompagné par votre médecin traitant, le service RH de votre entreprise, ou le médecin du travail pour constituer ce dossier. 
            Une fois accordée, la RQTH ouvre l’accès à des droits spécifiques pour vous aider à travailler dans de meilleures conditions.
        `,
    },
];

export default faqData;
